export default "__VITE_ASSET__CLuu76m$__"